import React, { useState, useEffect } from 'react';
import BackButton from '../../items/buttons/BackButton';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import AddLabel from './addLabel';
import Swal from 'sweetalert2';
import request from '../../../services/Request';
import { userLimits } from '../uitls/userLimits';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { Box, Typography, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import LabelIcon from '@mui/icons-material/Label';
import AddIcon from '@mui/icons-material/Add';

const getLabelsURL = `/labels/`;
const deleteLabelsURL = `/labels/delete/`;

export default function Label(props) {
  const theme = useTheme();
  const { _id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Labels',
    'edit_cate'
  );
  const [reflesh, setReflesh] = useState(false);
  const [labels, setLabels] = useState([]);
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [id, setID] = useState('');
  const [update, setUpdate] = useState(false);
  const [name, setName] = useState('');

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_label') ? localStorage.getItem('table_view_label') : 5
  );

  useEffect(() => {
    localStorage.setItem('table_view_label', pagination);
  }, [pagination]);

  useEffect(() => {
    let isCancelled = false;

    async function getMyLabels() {
      await request({
        method: 'get',
        url: !props.match.params.group && superAdmin ? getLabelsURL : getLabelsURL + _id,
      }).then((res) => {
        if (!isCancelled) {
          console.log(res.data);
          setLabels(res.data);
          setLoading(true);
        }
      });
    }
    getMyLabels();

    return () => {
      isCancelled = true;
    };
  }, [reflesh]);

  const deleteLabel = async (id) => {
    setLoading(false);
    await request({
      method: 'delete',
      url: deleteLabelsURL + id,
    }).then(() => {
      setLoading(true);
    });
    reflesh ? setReflesh(false) : setReflesh(true);
  };

  const columns = [
    {
      title: 'Label Name',
      field: 'name.en',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: theme.palette.primary.main }}>
          {rowData.name?.en}
        </Typography>
      ),
    },
  ];

  return (
    <ModernPageContainer>
      {!loading && <LoadingIcon />}
      <ModernPageHeader
        title={tableTitle || 'Labels'}
        subtitle="Manage your product labels"
        icon={LabelIcon}
        buttonText={access ? "Add Label" : undefined}
        buttonIcon={AddIcon}
        onButtonClick={access ? () => {
          setUpdate(false);
          setShow(true);
        } : undefined}
      />
      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={labels}
          editable={
            access && {
              onRowDelete: (newData, oldData) =>
                new Promise((resolve, reject) => {
                  setTimeout(() => {
                    deleteLabel(newData._id);
                    Swal.fire({
                      text: `A label has been successfully deleted: ${newData.name.en}`,
                      icon: 'success',
                    });
                    resolve();
                  }, 1000);
                }),
            }
          }
          actions={[
            () => access && {
              icon: 'edit',
              tooltip: 'Edit Label',
              onClick: (event, rowData) => {
                setID(rowData._id);
                setName(rowData.name);
                setUpdate(true);
                setShow(true);
              },
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100],
          }}
        />
        <Box sx={{ mt: 2 }}>
          <BackButton />
        </Box>
        <AddLabel
          referTo={_id}
          id={id}
          show={show}
          name={name}
          reflesh={reflesh}
          setReflesh={setReflesh}
          update={update}
          onHide={() => setShow(false)}
        />
      </Box>
    </ModernPageContainer>
  );
}